import React, { Component } from 'react';
import { withOktaAuth } from "@okta/okta-react";
// import axios from 'axios';
import Cookies from 'universal-cookie';

// components
import Header from '../components/Header';
import Footer from '../components/Footer';
// page content
import Form from './Form';
import Cleared from './Cleared';
import NotCleared from './NotCleared';

export default withOktaAuth(
  class Page extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isLoaded: false, email: null, training: null, lastsub: [], redirect: null, qrcode: this.qrcode(36),
      };
      this.reentryapi = process.env.REACT_APP_REENTRY_API;
    }

    componentDidMount() {
      const cookie = new Cookies();
      if(cookie.get('usahsVisitor-qrcode')) {
        this.setState({ qrcode: cookie.get('usahsVisitor-qrcode'), redirect: 'passed' })
      }

      this.setState({ isLoaded: true });
    }

    qrcode = (length) => {
      let result = '';
      let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }

      return result;
    }

    // pulls information from form when needed
    handleSubmission = (arg) => {
      // console.dir(arg);
      this.setState({ redirect: arg });
      document.querySelector('html').classList.remove('noscroll');
    }

    render() {
      let { isLoaded, redirect, qrcode } = this.state;
      // console.dir('redirect is ' + redirect);
      // console.dir('isLoaded is ' + isLoaded);

      return (
        <>
          {isLoaded && ( <Header data={ redirect } /> )}

            {/* Return Cleared if already submitted and clear */}
            {(isLoaded && redirect === 'passed') && (
              <Cleared data={ this.state } qrcode={ qrcode } />
            )}

            {/* Return NotCleared if already submitted and not clear */}
            {(isLoaded && redirect === 'failed') && (
              <NotCleared data={ this.state } qrcode={ qrcode } />
            )}

            {/* Return form for submission if trained and first attempt for the day */}
            {(isLoaded && redirect === null) && (
              <Form data={ this.state } qrcode={ qrcode } handleToUpdate={ this.handleSubmission.bind(this) } />
            )}

          {isLoaded && ( <Footer /> )}
        </>
      );
    }
  }
);